/*
    路由器对象模块
*/
import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../pages/Home/Home.vue'

import About from '../pages/About/About.vue'
import Profile from '../pages/About/Profile/Profile'
import Culture from '../pages/About/Culture/Culture'
import Honor from '../pages/About/Honor/Honor'

import Products from '../pages/Products/Products'
import ProductCover from '../pages/Products/ProductCover/ProductCover'
import ProductList from '../pages/Products/ProductList/ProductList'
import ProductSpecialList from '../pages/Products/ProductList/ProductSpecialList'

import ProductDetail from '../pages/Products/ProductDetail/ProductDetail'


import News from '../pages/News/News'
import NewsList from '../pages/News/NewsList/NewsList'
import NewsDetail from '../pages/News/NewsDetail/NewsDetail'

import Contact from '../pages/Contact/Contact'

import Other from '../pages/Other/Other'
import Privacy from '../pages/Other/Privacy/Privacy'
import Sitemap from '../pages/Other/Sitemap/Sitemap'
import Search from '../pages/Other/Search/Search'

import NoPage from '../pages/NoPage/NoPage'



Vue.use(VueRouter)
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new VueRouter({
    // mode:'hash',  //history,abstract,hash
    mode:'history',
    routes:[
        {   
            path:'/',
            component:Home
        },
        {
            path:'/about',
            component:About,
            children:[
                {
                    path:'/about/profile',
                    component:Profile
                },
                {
                    path:'culture',
                    component:Culture
                },
                {
                    path:'honor',
                    component:Honor
                },
                {
                    path:'',
                    component:Profile
                }
            ]
        },
        {
            path:'/products',
            component:Products,
            children:[
                {
                    path:'/products/productcover',
                    component:ProductCover
                },
                {
                    path:'productlist/12',
                    component:ProductSpecialList
                },
                {
                    path:'productlist/46',
                    component:ProductSpecialList
                },
                {
                    path:'productlist/:id',
                    component:ProductList
                },
                {
                    path:'productdetail/:id',
                    component:ProductDetail
                },
                {
                    path:'',
                    component:ProductCover
                }
            ],
            meta:{
                notKeepAlive: true
            }
        },
        {
            path:'/news',
            component:News,
            children:[
                {
                    path:'newslist',
                    component:NewsList
                },
                {
                    path:'newsdetail/:id',
                    component:NewsDetail
                },
                {
                    path:'',
                    component:NewsList
                }

            ]

        },
        {
            path:'/contact',
            component:Contact
        },
        {
            path:'/privacy',
            component:Other,
            children:[
                {
                    path:'/sitemap',
                    component:Sitemap
                },
                {
                    path:'/search',
                    component:Search
                },
                {
                    path:'',
                    component:Privacy
                }
            ]
        },
        {
            path:'*',
            component:NoPage

        }

    ],
    scrollBehavior(to,from,savedPosition){
        return { x:0,y:0}
    }

})



// WEBPACK FOOTER //
// ./src/router/index.js